import React from "react";

const STATUS_CLASS = {
  healthy: "owner-dashboard__health--healthy",
  watch: "owner-dashboard__health--watch",
  attention: "owner-dashboard__health--attention",
  critical: "owner-dashboard__health--critical",
};

const STATUS_LABEL = {
  healthy: "Looking good",
  watch: "Watch closely",
  attention: "Needs attention",
  critical: "Urgent",
};

const BusinessHealth = ({ health, dateRange, ga4 }) => {
  if (!health) return null;

  return (
    <section
      className={`owner-dashboard__panel owner-dashboard__health ${STATUS_CLASS[health.status] || ""}`}
    >
      <div className="owner-dashboard__health-layout">
        <div className="owner-dashboard__health-main">
          <div className="owner-dashboard__health-title-row">
            <p className="owner-dashboard__eyebrow">Business snapshot</p>
            <span className="owner-dashboard__status-pill">
              {STATUS_LABEL[health.status] || health.status}
            </span>
          </div>
          <h2 className="owner-dashboard__health-headline">{health.headline}</h2>
          <p className="owner-dashboard__health-summary">{health.summaryText}</p>
          <p className="owner-dashboard__health-meta">
            Jackrabbit live data
            {ga4?.connected
              ? ` · Website activity (last ${dateRange?.days || 30} days)`
              : ga4?.configured
                ? " · Website stats unavailable this refresh"
                : " · Connect GA4 for website signals"}
          </p>
        </div>

        <div className="owner-dashboard__health-metrics">
          {(health.metrics || []).map((metric) => (
            <div
              key={metric.label}
              className={`owner-dashboard__stat-tile owner-dashboard__stat-tile--${metric.tone || "neutral"}`}
            >
              <span className="owner-dashboard__stat-tile-value">{metric.value}</span>
              <span className="owner-dashboard__stat-tile-label">{metric.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessHealth;
